import React from 'react'
import { PAYMENT_STATUS } from '../../constants/common'
import { formattedDate } from '../../utils/formattedDate';

const Billing = ({ billing }) => {
    const paymentStatus = PAYMENT_STATUS;

    return (
        <div className='angel-admin-billing'>
            <div className='angel-billing-section'>
                <div className="billing-list">
                    {
                        billing?.map((item, index) => {
                            const matchedStatus = paymentStatus.find(status => status.key === item?.status);
                            const displayStatus = matchedStatus?.value || item?.status;
                            const statusClass = displayStatus === 'Success' ? 'success' : displayStatus === 'Failed' ? 'failed' : 'refund';
                            return <div className='billing-list-card' key={index}>
                                <div className='card-description'>
                                    <div className={`list-name ${statusClass}`}>Payment {displayStatus} {item?.amount ? `($${item?.amount})` : ''}</div>
                                </div>
                                <div className='card-time'>
                                    {formattedDate(item?.paymentDate)}
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Billing